<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="unnumbered-1">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PRAISE FOR CJ LYONS’ THRILLERS WITH HEART:</h1>
</div>
</div>
</div>
</div>
<div class="text" id="unnumbered-1-text">
<p class="first first-in-chapter first-full-width"><span class="first-phrase">"Everything a great thriller should be—action</span> packed, authentic, and intense." ~#1 New York Times bestselling author Lee Child</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"A compelling new</span> voice in thriller writing…I love how the characters come alive on every page." ~New York Times bestselling author Jeffery Deaver  </p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Top Pick!</span> A fascinating and intense thriller." ~ RT Book Reviews</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"An intense,</span> emotional thriller…(that) climbs to the edge of intensity." ~National Examiner</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"A perfect blend</span> of romance and suspense. My kind of read." ~#1 New York Times Bestselling author Sandra Brown</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Highly engaging characters,</span> heart-stopping scenes…one great rollercoaster ride that will not be stopping anytime soon." ~Bookreporter.com</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Adrenalin pumping."</span> ~The Mystery Gazette</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Riveting."</span> ~Publishers Weekly Beyond Her Book</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">Lyons "is a master within the genre."</span> ~Pittsburgh Magazine</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Will leave</span> you breathless and begging for more." ~Romance Novel TV</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"A great fast-paced read….Not</span> to be missed." ~Book Addict</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Breathtakingly fast-paced."</span> ~Publishers Weekly</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Simply superb…riveting drama…a perfect ten."</span> ~Romance Reviews Today</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Characters with beating</span> hearts and three dimensions." ~Newsday</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"A pulse-pounding adrenalin rush!"</span> ~Lisa Gardner</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Packed with adrenalin."</span> ~David Morrell</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"…Harrowing, emotional, action-packed and brilliantly realized."</span> ~Susan Wiggs</p>
<p class="implicit-break scene-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">"Explodes on the page…I</span> absolutely could not put it down." ~Romance Readers' Connection</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise-for-cj-lyons-thrillers-with-heart.vue?15086b9b